import React, { useMemo } from "react";
import { Chip, Menu, MenuItem } from "@mui/material";
import { IconArrowsRotate, IconCircleArrowDown } from "components/icons";
import { useMprcTheme } from "components/MprcThemeProvider";

export type AutoSelectValue = {
    key: number | string;
    label: string;
};

interface IProps {
    optionsItems: AutoSelectValue[];
    value: AutoSelectValue | null;
    useMenu: boolean;
    onChange: (item: AutoSelectValue) => void;
}

type Props = IProps;

export const MprcAutoSelect: React.FC<Props> = (props) => {

    const { value, useMenu, optionsItems, onChange } = props;
    const [anchor, setAnchor] = React.useState<Element | null>(null);

    const { theme } = useMprcTheme();

    // Opções do menu
    const menuItems = useMemo(() => {
        var arr: React.ReactNode[] = [];
        optionsItems.forEach((v, index) => {
            arr.push(
                <MenuItem
                    key={v.key}
                    onClick={
                        () => {
                            onChange(v);
                            setAnchor(null);
                        }
                    }
                >
                    {v.label}
                </MenuItem>
            );
        });
        return arr;
    }, [optionsItems]);


    ////////////////////////////////////////////////////////////////////////////
    /// Handles
    ////////////////////////////////////////////////////////////////////////////

    /// Clique do Chip
    const handleClick = (event: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLDivElement>) => {

        if (useMenu) {
            setAnchor(event.currentTarget);
        }
        else if (value) {
            const currentIndex = optionsItems.indexOf(value);
            const nextIndex = (currentIndex + 1) % optionsItems.length;
            onChange(optionsItems[nextIndex]);
        }
        else if (optionsItems.length > 0) {
            onChange(optionsItems[0]);
        }
    };


    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <>
            <Chip
                label={value?.label ?? theme.MprcAutoSelect.noOptionsText}
                size="small"
                sx={[
                    {
                        '&:hover': {
                            color: "#000",
                            opacity: "1",
                            backgroundColor: "#ed6c02",
                        },
                    },
                    {
                        backgroundColor: "#ed6c02",
                        opacity: "0.8",
                        color: "#000",
                    }]}
                deleteIcon={useMenu ? <IconCircleArrowDown /> : <IconArrowsRotate />}
                onClick={(e) => handleClick(e)}
                onDelete={(e) => handleClick(e)}
            />

            { useMenu &&
                <Menu
                    anchorEl={anchor}
                    open={anchor != null}
                    onClose={() => setAnchor(null)}
                >
                    {menuItems}
                </Menu>
            }
        </>
    );
};
